import { render, staticRenderFns } from "./JoinAccount.vue?vue&type=template&id=1ace4730"
import script from "./JoinAccount.vue?vue&type=script&lang=js"
export * from "./JoinAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports